import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-warning",
  "use": "icon-warning-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-warning\"><defs><style type=\"text/css\"></style></defs><path d=\"M512 56.889c221.867 0 398.222 176.355 398.222 398.222v398.222H113.778V455.111C113.778 233.244 290.133 56.89 512 56.89z m341.333 739.555V455.111c0-187.733-153.6-341.333-341.333-341.333s-341.333 153.6-341.333 341.333v341.333h682.666zM113.778 910.222h796.444v56.89H113.778z\" fill=\"#73777A\" p-id=\"4680\" /><path d=\"M392.533 699.733l39.823 39.823L705.422 460.8H477.867L659.91 284.444l-39.822-39.822L341.333 517.69H568.89z\" fill=\"#73777A\" p-id=\"4681\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/warning.svg
// module id = TcIt
// module chunks = 1